// Appearance (Light / Dark) and the colours CSS cannot reach.
//
// The choice is kept per browser in localStorage and applied as
// <html data-theme="light|dark">. Light is the default. public/index.html
// applies the saved choice before first paint, so a dark user never sees a
// white flash; setTheme() keeps it in step after.

export const THEME_KEY = 'intelvo-theme';
export const THEMES = ['light', 'dark'];
const CHANGE_EVENT = 'intelvo-themechange';

export function getTheme() {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
}

export function setTheme(theme) {
  const next = theme === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(THEME_KEY, next);
  } catch (e) {
    // private window or blocked storage: the choice lasts for this page only
  }
  document.documentElement.setAttribute('data-theme', next);
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: next }));
}

export function cssVar(name, fallback = '') {
  try {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
  } catch (e) {
    return fallback;
  }
}

// The colours an on-screen chart draws its frame with.
export function chartTheme() {
  return {
    grid: cssVar('--color-border', '#E5E7EB'),
    tick: cssVar('--color-text-muted', '#6B7280'),
    title: cssVar('--color-text-secondary', '#4B5563'),
    surface: cssVar('--color-surface', '#FFFFFF'),
    font: cssVar('--font-ui', 'Inter, sans-serif'),
  };
}

// Calls back when the user switches appearance, so a canvas can redraw in the
// new colours. Returns the function that stops listening.
export function onAppearanceChange(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}
